/**
 * Contact tabs
 *
 * @since   1.0.0
 * @package blujay
 */

(function($) {
    $(document).ready(function() {
        //stuff
        var tabs = $("div#tabs");
        var accordion = $("div.accordion");

		if ( tabs.length < 1 ) {
			return;
		} else {
			//tabs stuff
	        tabs.tabs();
	        accordion.accordion({heightStyle: "content", icons: false});
		}

    }); // document.ready
})(jQuery);
